import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import React from 'react'
import { connect } from 'react-redux'

import { activeCitationSelector } from '@chegg-wt/core/state/citation/selectors'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import Content from './Content'
import { getBookFields, getJournalFields, getWebsiteFields } from './fields'

interface Props {
  sourceData: Citation
  style?: string
}

// TODO these can be recast as true selectors

const getSourceFields = (sourceType, sourceData, style) => {
  switch (sourceType) {
    case 'book':
      return getBookFields(sourceData)
    case 'journal':
      return getJournalFields(sourceData)
    default:
      return getWebsiteFields(sourceData, style)
  }
}

export const CitationContent: React.FunctionComponent<Props> = ({
  sourceData,
  style,
}) => {
  const source = sourceData && sourceData.source
  if (!source) return null
  return <Content fields={getSourceFields(source, sourceData, style)} />
}

const mapStateToProps = (state) => ({
  sourceData: activeCitationSelector(state),
  style: currentStyleSelector(state),
})

export default connect(mapStateToProps)(CitationContent)
